import { computed, toValue, type MaybeRefOrGetter } from "vue";
import type { CanvassListItem } from "./types";

export function useCanvassesByParticipationState(
  canvasses: MaybeRefOrGetter<Array<CanvassListItem> | undefined>,
) {
  const myCanvasses = computed(() =>
    (toValue(canvasses) ?? []).filter(
      (canvass) => canvass.currentUserParticipationState === "participating",
    ),
  );

  const joinableCanvasses = computed(() =>
    (toValue(canvasses) ?? []).filter(
      (canvass) =>
        canvass.currentUserParticipationState === "pending" ||
        (canvass.currentUserParticipationState === "none" && canvass.public),
    ),
  );

  return { myCanvasses, joinableCanvasses };
}
